/* eslint-disable prefer-const */
/**
 * Copyright (c) 2018 itemis AG - All rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 *
 * Contributors:
 * 	andreas muelder - itemis AG
 *
 */
import * as ace from "ace-builds";

ace.define("ace/mode/stext_highlighting_rules", function (require, exports) {
  let oop = ace.require("ace/lib/oop");
  let TextHighlightRules = ace.require("ace/mode/text_highlight_rules").TextHighlightRules;

  let DiagramHighlightRules = function () {
    let keywords =
      "every|always|oncycle|after|exit|" +
      "entry|namespace|interface|internal|" +
      "import|event|local|in|out|const|var|" +
      "readonly|operation|default|else|raise|s|ms|us|ns";

    let builtinConstants = "true|false|yes|no";

    let builtinFunctions = "valueof|active";

    let keywordMapper = this.createKeywordMapper(
      {
        "support.function": keywords + "|" + builtinFunctions,
        "constant.language": builtinConstants,
      },
      "identifier",
      true
    );

    this.$rules = {
      start: [
        {
          token: "comment",
          regex: "\\/\\/.*$",
        },
        {
          token: "comment", // multi line comment
          regex: "\\/\\*",
          next: "comment",
        },
        {
          token: "string", // single line
          regex: '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]',
        },
        {
          token: "string", // single line
          regex: "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']",
        },
        {
          token: "constant.numeric", // hex
          regex: /0(?:[xX][0-9a-fA-F][0-9a-fA-F_]*|[bB][01][01_]*)[LlSsDdFfYy]?\b/,
        },
        {
          token: "constant.numeric", // float
          regex: /[+-]?\d[\d_]*(?:(?:\.[\d_]*)?(?:[eE][+-]?[\d_]+)?)?[LlSsDdFfYy]?\b/,
        },
        {
          token: "constant.language.boolean",
          regex: "(?:true|false)\\b",
        },
        {
          regex: "(open(?:\\s+))?module(?=\\s*\\w)",
          token: "keyword",
          next: [
            {
              regex: "{",
              token: "paren.lparen",
              next: [
                {
                  regex: "}",
                  token: "paren.rparen",
                  next: "start",
                },
              ],
            },
            {
              token: "text",
              regex: "\\s+",
            },
            {
              token: "identifier",
              regex: "\\w+",
            },
            {
              token: "punctuation.operator",
              regex: ".",
            },
            {
              token: "text",
              regex: "\\s+",
            },
            {
              regex: "",
              next: "start",
            },
          ],
        },
        {
          token: keywordMapper,
          regex: "[a-zA-Z_$][a-zA-Z0-9_$]*\\b",
        },
        {
          token: "keyword.operator",
          regex:
            "!|\\$|%|&|\\*|\\-\\-|\\-|\\+\\+|\\+|~|===|==|=|!=|!==|<=|>=|<<=|>>=|>>>=|<>|<|>|!|&&|\\|\\||\\?\\:|\\*=|%=|\\+=|\\-=|&=|\\^=",
        },
        {
          token: "lparen",
          regex: "[[({]",
        },
        {
          token: "rparen",
          regex: "[\\])}]",
        },
        {
          token: "text",
          regex: "\\s+",
        },
      ],
      comment: [
        {
          token: "comment", // closing comment
          regex: "\\*\\/",
          next: "start",
        },
        {
          defaultToken: "comment",
        },
      ],
    };
    this.normalizeRules();
  };

  oop.inherits(DiagramHighlightRules, TextHighlightRules);

  exports.DiagramHighlightRules = DiagramHighlightRules;
});

ace.define("ace/mode/stext", function (require, exports) {
  "use strict";
  let oop = ace.require("ace/lib/oop");
  let TextMode = require("ace/mode/text").Mode;
  let Tokenizer = require("../tokenizer").Tokenizer;
  let DiagramHighlightRules = require("ace/mode/stext_highlighting_rules").DiagramHighlightRules;
  //var FoldMode = require("./folding/cstyle").FoldMode;

  let Mode = function () {
    let highlighter = new DiagramHighlightRules();
    //this.foldingRules = new FoldMode();
    this.$tokenizer = new Tokenizer(highlighter.getRules());
    this.$keywordList = highlighter.$keywordList;
  };
  oop.inherits(Mode, TextMode);

  (function () {
    this.lineCommentStart = "'";
  }).call(Mode.prototype);

  exports.Mode = Mode;
});
